import PropTypes from 'prop-types';
import React from 'react';
import './ProgressBar.scss';

export const ProgressBar = ({ numberOfSteps, currentStep }) => {
  // Create an array of step numbers starting at 1
  const steps = []

  for (let i = 1; i <= numberOfSteps; i++) {
    steps.push(i)
  }

  return (
    <div className="m-progress-bar__container">
      {steps.map((step, i) =>
        <div key={step} className={step === currentStep ? "m-progress-bar__step current" : "m-progress-bar__step"}>{step}
        </div>
      )}
    </div>
  )
}


ProgressBar.propTypes = {
  numberOfSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
}
